import { unixToDate } from './date';

export function isEmpty(arr: any[]) {
    return arr.length === 0;
}

export const shuffle = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

export const insert = (array: any[], el: any, index?: number) => {
    return arrayAppend(array, el, index);
};

function arrayAppend(arr: any[], el: any, index?: any) {
    let spliceArgs: any;
    index = +index;
    if (isNaN(index)) {
        index = arr.length;
    }
    spliceArgs = [index, 0];
    if (isDefined(el)) {
        spliceArgs = spliceArgs.concat(el);
    }
    arr.splice.apply(arr, spliceArgs);
    return arr;
}

function isDefined(o: any) {
    return o !== undefined;
}

export const remove = (array: any[], el: any) => {
    return arrayRemove(array, el);
};

function arrayRemove(arr: any[], value: any) {
    var i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
}

export function uniqBy(arr: any = []) {
    const uniqueArray = Array.from(
        new Set(arr.map((item: any) => item.id))
    ).map((id) => {
        return arr.find((item: any) => item.id === id);
    });
    return uniqueArray;
}

export function findIndex(str: string) {
    var num = /\d/;
    var nums: any = str.match(num);
    return str.indexOf(nums);
}

export function groupByDate(items: any, format: string = 'dddd, DD/MM/YYYY') {
    if (!items) {
        return [];
    }
    let group: any = [];
    items.forEach((item: any) => {
        const key = unixToDate(item.startTime, format);
        if (!group[key]) {
            group[key] = [];
        }
        group[key].push(item);
    });
    return group;
}

export function groupByRound(items: any, isGroup?: boolean) {
    let group: any = [];
    items.forEach((item: any) => {
        let key: string = '';
        const roundName: string = item?.round?.name || '';
        if (isGroup) {
            key = roundName.split('-')[1] ? roundName.split('-')[1] : roundName;
        }
        if (!group[key]) {
            group[key] = [];
        }
        group[key].push(item);
    });
    return group;
}

export function groupByGroup(items: any[]) {
    let group: any = [];
    items.forEach((item) => {
        let key: string = item?.group?.name || '';
        if (!group[key]) {
            group[key] = [];
        }
        group[key].push(item);
    });
    return group;
}

export function groupByPosition(items: any[]) {
    let group: any = [];
    items.forEach((item) => {
        let key: string = item?.position?.name;
        if (!group[key]) {
            group[key] = [];
        }
        group[key].push(item);
    });
    return group;
}

export function splitArr(arr: any[], perChunk = 3) {
    return arr.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
    }, []);
}
